import React from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import ImportLanding from './landing'
import MailchimpFlow from './flow'
import { IMPORT_PATH, MAILCHIMP_FLOW_PATH } from './paths'

export default function ImportIndex() {
    const { pathname } = useLocation()
    const inFlow = pathname.indexOf(MAILCHIMP_FLOW_PATH) === 0

    if (pathname !== IMPORT_PATH && !inFlow) {
        return <Redirect to={IMPORT_PATH} />
    }

    return (
        <>
            <div aria-hidden={inFlow ? 'true' : undefined}>
                <ImportLanding active={!inFlow} />
            </div>
            {inFlow && <MailchimpFlow />}
        </>
    )
}
